<!-- Created by hw on 2020/2/17-->
<template></template>

<script>
import qs from "qs";
import router from '../../router'
export default {
  data() {
    return {
      timer: null
    };
  },
  methods: {
    init() {
      // if (this.timer == null) {
      //   this.openMessage();
      // }
      // this.timer = setInterval(this.openMessage, 60 * 15 * 1000);

        // 只弹出一次
        // this.openMessage();
    },
    openMessage() {
      const that = this;
      //获取待办接口
      this.$http
        .get("/api/1/workflow/tasks.json", {
          params: {},
          paramsSerializer: function(params) {
            return qs.stringify(params, { indices: false });
          }
        })
        .then(function(response) {
          if (response.page) {
            if (response.page.total != 0) {
              that.message(response.page.total);
            }
          }
        });
    },
    message(number) {
      const that = this;
      that.$notification.open({
        message: "消息提醒",
        description: (
          <div style="float: left;">
            您有 <b style="color:red;">{number}</b> 个待办件，请安排时间处理
          </div>
        ),
        duration: 60 * 3,
        style: {
          width: "calc(-60px + 100vw)",
        },
        class: "qqq",
        placement: "bottomLeft",
        icon: <a-icon type="message" style="color: #108ee9" />,
        btn: h => {
          return h(
            "a-button",
            {
              props: {
                type: "primary",
                size: "small"
              },
              on: {
                click: function() {
                  router.replace("/workflow/task");
                }
              }
            },
            "查看"
          );
        }
      });
    }
  }
};
</script>

<style>
.ant-notification.ant-notification-bottomLeft {
  margin-right: 0;
  margin-left: 24px;
  z-index: 1 !important;
}
.qqq .ant-notification-notice-btn {
  margin-left: 20px !important;
  float: left !important;
  margin-top: 0px !important;
}
</style>
